<template>
    <div class="paket-list">
        <div v-for="(data, key) in dataList" :key="`card-pesan-${key}`" class="m-d-16">
            <SOSlotCard
                :id="`outlet-${data.idoutlet}`"
                :card-type="'none'"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
                :last-id="getLastId"
            >
                <template v-slot:card_body>
                    <div
                        style="padding-left: 2px; padding-right: 2px;"
                        class="d-grid-12"
                        @click="gotoPengaturan(data.idoutlet)"
                    >
                        <img
                            v-if="data.logo_url"
                            :src="imgBucketSrc + data.logo_url"
                            class="grid-rspan-2 grid-cspan-1 m-r-4"
                            width="36"
                            height="36"
                        />
                        <img
                            v-else
                            src="../../../assets/gambar/Rectangle43.svg"
                            class="grid-rspan-2 grid-cspan-1 m-r-4"
                            width="36"
                            height="36"
                        />
                        <label class="grid-cspan-7 m-d-0 m-l-12 p-l-8">{{ data.nama }}</label>
                        <div class="grid-cspan-4 text-right">
                            <IconBased :width="8" :height="12">
                                <template v-slot:icons>
                                    <NextStep icon-fill="#C8D0DD"/>
                                </template>
                            </IconBased>
                        </div>
                        <label class="grid-cspan-10 f-c-midgrey f-13 m-d-0 m-l-12 p-l-8" v-if="data.count_pengaturan > 0">
                            {{ data.count_pengaturan }} Pengaturan aktif
                        </label>
                        <label class="grid-cspan-10 f-c-midgrey f-13 m-d-0 m-l-12 p-l-8" v-else>
                            Belum ada pengaturan
                        </label>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import IconBased from "../components/iconPack/IconBased.vue";
import NextStep from "../components/iconPack/NextStep0812.vue";

import { moduleName } from "../store/state";

export default {
    name: "CardOutlet",
    props: {
        dataList: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            bucketUrl: {
                dalbo: "https://storage.googleapis.com/ember-e-dalbo/",
                ages: "https://storage.googleapis.com/",
            },
            imgBucketSrc: "",
        };
    },
    mounted() {
        this.imgBucketSrc = process.env.NODE_ENV !== "production" ? this.bucketUrl.ages : this.bucketUrl.dalbo;
    },
    components: {
        SOSlotCard,
        IconBased,
        NextStep,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            pageOutlet: "pageOutlet",
            endOutlet: "endOutlet",
            totalOutlet: "totalOutlet",
        }),
        getLastId() {
            return this.endOutlet.id ? `outlet-${this.endOutlet.id}` : "";
        },
        getIdDevice() {
            return this.$route.params.id_device;
        },
    },
    methods: {
        ...mapActions({
            getListOutlet: `${moduleName}/getListOutlet`,
            setLoadMore: `${moduleName}/setLoadMore`,
            toggleDisplayOutlet: `${moduleName}/toggleDisplayOutlet`,
        }),
        gotoPengaturan(idOutlet) {
            this.smartTrackingClick('detail_outlet_integrasi_whatsapp')
            this.$router.push({
                name: "wa_autosender.detail_perangkat.daftar_oulet.set_draft",
                params: { id_outlet: idOutlet },
            });

        },
        async doLoadMore() {
            if (this.totalOutlet > this.pageOutlet.length) {
                if (!this.isFetching) {
                    await this.setLoadMore(true);
                    this.getListOutlet({ iddevice: this.getIdDevice });
                }
            }
        },
        toggleCard(data) {
            this.toggleDisplayOutlet(data);
        },
    },
};
</script>
<style scoped>
.p-x-2 {
    padding-left: 2px;
    padding-right: 2px;
}
.text-msg {
    background: #fafafa;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 0px 10px;
}
.text-msg .msg {
    display: block;
    display: -webkit-box;
    height: 40px;
    overflow: hidden;
    line-height: 1.5;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.text-transaksi {
    background: #ededed;
    border-radius: 8px 0px 8px 0px;
    width: fit-content;
    padding: 2px 10px;
    margin-bottom: 6px;
    margin-left: -10px;
}
.status-pesan {
    width: fit-content;
    padding: 0px 4px;
    border-radius: 3px;
}
.gagal {
    background-color: #fff1f1;
    color: #964040;
}
.sukses {
    background-color: #e8fcee;
    color: #40964c;
}
.warning {
    background-color: #fff8e1;
    color: #c29500;
}

.foot {
    padding-top: 4px;
    padding-bottom: 4px;
}

.nama-cs {
    max-width: 75px;
}

@media (min-width: 350px) {
    .nama-cs {
        max-width: 105px;
    }
}

@media (min-width: 370px) {
    .nama-cs {
        max-width: 127px;
    }
}

@media (min-width: 400px) {
    .nama-cs {
        max-width: 150px;
    }
}

@media (min-width: 450px) {
    .nama-cs {
        max-width: 200px;
    }
}

@media (min-width: 470px) {
    .nama-cs {
        max-width: 230px;
    }
}
</style>
